import {
  Box,
  Flex,
  HStack,
  Text,
  IconButton,
  Image,
  useDisclosure,
  useColorModeValue,
  Stack,
} from '@chakra-ui/react'
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { Outlet, Link as LinkRouter } from "react-router-dom";
import Appox_logo from './Appox_logo.svg';
import Lang from '../Lang';

const Links = ["Home", "AI-Teens", "AI-Prof", "AI-SmallBusiness"];

const NavLink = (props) => {
  const { children } = props;

  return (
    <Box
      as="a"
      py={2}
      px={4}
      mt={{ md: 10, xl: 16 }}
      rounded={'md'}
      _hover={{
        textDecoration: 'none',
        bg: 'gray.900',
      }}
      href={children === "Home" ? "/" : children}
    >
      <Text
        fontSize={"20px"}
        color="gray.50"
      >
        <Lang text={children} />
      </Text>
    </Box>
  )
}

export default function NavBar() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        color='gray.50'
        px={4}
        align="center"
        id="up"
      >

        <Flex
          h={{ md: 10, xl: 20 }}
          alignItems={'center'}
          justifyContent={{ base: 'space-between', md: 'space-between' }}
          maxW={"8xl"}
          px={{ base: 1, md: 4 }}
          pb={{ md: 10, xl: 16 }}
        >

          <HStack
            as={'nav'}
            spacing={4}
            alignItems={'center'}
            justifyContent={{ md: 'space-between', xl: "space-between" }}
            maxW={"8xl"}
            w={"full"}
            display={{ base: 'none', md: 'flex' }}
          >
            <LinkRouter to="/">
              <Image
                h={"30px"}
                w={"106px"}
                mt={{ md: 10, xl: 16 }}
                src={Appox_logo}
                title='Go to home'
                alt='AppOX logo'
              />
            </LinkRouter>
            {Links.map((link) => (
              <NavLink key={link}>{link}</NavLink>
            ))}
          </HStack>

          <LinkRouter to="/">
            <Image
              h={"25px"}
              w={"90px"}
              my={2}
              src={Appox_logo}
              display={{ base: 'flex', md: 'none' }}
              title='AppOX'
              alt='AppOX logo' />
          </LinkRouter>

          <IconButton
            size={'sm'}
            icon={isOpen ? <CloseIcon boxSize={5} /> : <HamburgerIcon boxSize={5} />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
            bg={''}
            color={useColorModeValue('gray.50', 'gray.100')}
            my={2}
          />

        </Flex>

        {isOpen ? (
          <Box
          display={{ md: 'none' }}
          h={255} >
            <Stack 
            as={'nav'} 
            spacing={2}
            >
              {Links.map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </Stack>
          </Box>
        ) : null}

      </Box>

      <Box id="detail" ><Outlet /></Box>   {/* Don't delete this line. This is used to render content view. */}
    </>)
}